"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var DownloadDebugButton = function (_a) {
    var stateReport = _a.stateReport;
    return (react_1["default"].createElement("a", { href: 'data:text/json;charset=utf-8,' + encodeURIComponent(JSON.stringify(stateReport)), download: "bug-report.json", className: "download-debug-button" }, "Bug-Report herunterladen"));
};
exports["default"] = DownloadDebugButton;
